import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { sxButtonTextBack } from './sxProps';
import PendenciaCard from './reembolsoDetalheCards/PendenciaCard';
import AprovadoCard from './reembolsoDetalheCards/AprovadoCard';
import ConcluidoCard from './reembolsoDetalheCards/ConcluidoCard';
import RecusadoCard from './reembolsoDetalheCards/RecusadoCard';
import LoadingApp from '../../../../components/LoadingApp';
import ModalFeedBack from '../../../../components/ModalFeedBack';
import { getAnexoReembolso, getdadosrevisaoprodutoexecutivo, gravaarquivospedidoreembolso, gravarresppendenciaouvidorreembolso } from '../../../../services/Financeiro/ReembolsoService';
import { PedidoReembolsoDetalhe as PedidoReembolsoDetalheEntity } from '../../../../interfaces/entities/Reembolso/PedidoReembolsoDetalhe';
import { Anexo } from '../../../../interfaces/entities/Reembolso/Anexo';
import EmAnaliseCard from './reembolsoDetalheCards/EmAnaliseCard';
import { downloadBase64File } from '../../../../utils/DownloadFile';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';

const PedidoReembolsoDetalhe = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [modalFeedback, setmodalFeedback] = useState<null | { icon?: 'error' | 'success', title?: string, textButton?: string, subTitle?: string, action: () => void }>(null);
  const [reembolso, setreembolso] = useState<PedidoReembolsoDetalheEntity>();
  const { id, status } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const acessoReanalise = location.state?.acessoReanalise;

  const accessibility = useAccessibility();

  useEffect(() => {
    getReembolso();
  }, [])

  const getReembolso = async () => {
    setLoading(true);
    const response = await getdadosrevisaoprodutoexecutivo(parseInt(id || "0"));
    if (response?.status !== 200) {
      setmodalFeedback({
        icon: 'error',
        title: 'Ocorreu um erro',
        subTitle: 'Falha ao buscar solicitações.',
        textButton: 'Fechar',
        action: () => setmodalFeedback(null)
      });
      setLoading(false);
      return;
    }
    setreembolso(response?.data);
    setLoading(false);
  }

  const solicitarReembolso = async (anexos: Array<Anexo>, idPedidoReembolso: number, novoVlr: number, obs: string) => {
    setLoading(true);

    var response;
    if (anexos?.length) {
      response = await gravaarquivospedidoreembolso(idPedidoReembolso, anexos);
      if (response?.status !== 200) {
        setmodalFeedback({
          icon: 'error',
          title: 'Ocorreu um erro',
          subTitle: 'Você pode anexar arquivos .pdf, .jpg, .doc e .png de até 4mb, sendo de notas fiscais/recibos, pedidos médicos, relatórios médicos, entre outros.',
          textButton: 'Fechar',
          action: () => setmodalFeedback(null)
        });
        setLoading(false);
        return;
      }
    }
    

    response = await gravarresppendenciaouvidorreembolso(idPedidoReembolso, novoVlr, obs);
    if (response?.status !== 200) {
      setmodalFeedback({
        icon: 'error',
        title: 'Ocorreu um erro',
        subTitle: 'Falha ao realizar solicitação.',
        textButton: 'Fechar',
        action: () => setmodalFeedback(null)
      });
      setLoading(false);
      return;
    }

    setmodalFeedback({
      icon: 'success',
      title: 'Sucesso',
      subTitle: 'Solicitação realizada com sucesso.',
      textButton: 'Fechar',
      action: () => {
        navigate(-1);
        setmodalFeedback(null);
      }
    });
    setLoading(false);
  }

  const getAnexo = (idPedido: string | undefined, idAnexo: string) => {
    if (!idPedido) return;
    getAnexoReembolso(idPedido, idAnexo)
      .then(response => {
        downloadBase64File(response.base64, response?.nome);
      })
  }

  return (
    <div className='meus-reembolsos-container'>
      <h1 className='container-title' style={accessibility.textTitleStyleAccessibility}>Meus reembolsos</h1>
      <div className="meus-reembolsos-list">

        {status === 'Emanalise' ? <EmAnaliseCard reembolso={reembolso} onAnexoClicked={idAnexo => getAnexo(reembolso?.idPedidoReembolso, idAnexo)}/> :
          status === 'Pendencia' ? <PendenciaCard acessoReanalise={acessoReanalise} solicitarReembolso={solicitarReembolso} reembolso={reembolso} /> :
            status === 'Aprovado' ? <AprovadoCard reembolso={reembolso} onAnexoClicked={idAnexo => getAnexo(reembolso?.idPedidoReembolso, idAnexo)} /> :
              status === 'Concluido' ? <ConcluidoCard reembolso={reembolso} onAnexoClicked={idAnexo => getAnexo(reembolso?.idPedidoReembolso, idAnexo)}/> :
                <RecusadoCard reembolso={reembolso} onAnexoClicked={idAnexo => getAnexo(reembolso?.idPedidoReembolso, idAnexo)} />}

        <div className='container-button-back-servicos'>
          <Button
            onClick={() => navigate(-1)}
            startIcon={<FontAwesomeIcon style={accessibility.textTitleStyleAccessibility} icon={faChevronLeft} color="#383838" />}
            aria-label="Voltar para meus reembolsos"
          >
            <Typography style={accessibility.textTitleStyleAccessibility} sx={sxButtonTextBack}>Voltar</Typography>
          </Button>
        </div>
        <LoadingApp showLoading={loading} />
        <ModalFeedBack
          showModal={modalFeedback ? true : false}
          icon={modalFeedback?.icon as 'success' | 'error'}
          textButton={modalFeedback?.textButton as string}
          title={modalFeedback?.title as string}
          subTitle={modalFeedback?.subTitle as string}
          handleShowModal={modalFeedback?.action}
          showButtonModal
          handleButtonModal={modalFeedback?.action}
        />
      </div>
    </div>
  )
}

export default PedidoReembolsoDetalhe